import request from "@/config/_request";
import qs from "qs";

//获得置顶教研活动列表
export function activityList(params) {
    return request({
      url: "/api/get/top/research/activity/list",
      params,
      method: "get",
    });
  }
  //教研活动报名或取消报名接口
  export function signUp(params) {
    return request({
      url: "/api/add/or/delete/research/activity/tch",
      data: qs.stringify(params),
      method: "post",
    });
  }
  //获得往期教研活动列表
  export function previousPeriod(params) {
    return request({
      url: "/api/get/past/research/activity/list",
      params,
      method: "get",
    });
  }

  //教师端获得师训列表
  export function getTchTrainingList(params) {
    return request({
      url: "/api/get/tch/training/list",
      params,
      method: "get",
    });
  }
//师训详情
export function getTchTrainInfo(params) {
  return request({
    url: "/api/get/tch/training/info",
    params,
    method: "get",
  });
}